export enum CultureLabel {
  cane = 'Cana-de-açúcar',
  soybean = 'Soja',
  corn = 'Milho',
}
export type Culture = keyof typeof CultureLabel
